module.exports = __webpack_public_path__ + "img/logo7.bd7a50b7.png";